import { readStoredValue, writeStoredValue } from './storage';

export type AppLocale = 'en' | 'ko';

export const LOCALE_STORAGE_KEY = 'agentteams-locale';
export const APP_LOCALE_CHANGED_EVENT = 'agentteams-app-locale-changed';

export const SUPPORTED_LOCALES: readonly AppLocale[] = ['en', 'ko'];
export const DEFAULT_LOCALE: AppLocale = 'en';

export const isAppLocale = (value: unknown): value is AppLocale => {
  return value === 'en' || value === 'ko';
};

export const getStoredLocale = (): AppLocale => {
  // 저장소 차단 환경(iPad Safari 사생활 모드 등)에서는 기본 로케일로 동작한다 (WEB-R).
  const stored = readStoredValue(LOCALE_STORAGE_KEY);
  return isAppLocale(stored) ? stored : DEFAULT_LOCALE;
};

export const saveStoredLocale = (locale: AppLocale) => {
  writeStoredValue(LOCALE_STORAGE_KEY, locale);
  // 저장은 SSR 안전 헬퍼에 맡기고, 이 가드는 dispatchEvent(window API) 전용이다.
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(APP_LOCALE_CHANGED_EVENT));
};
